import { Record } from 'immutable';
import { ConfigLevelType } from './config-level-type';
import { ConfigLookupType } from './config-lookup-type';

const ConfigResponseRecord = Record({
  config: null,
  value: null,
  level: null,
  propertyId: null
});

export class ConfigResponse extends ConfigResponseRecord {
  config: ConfigLookupType;
  value: string;
  level: ConfigLevelType;
  propertyId: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/config/config-response.ts